import React from 'react'
import Announcement from '../components/Announcement'
import Navbar from '../components/Navbar'
import Slider from '../components/Slider'
import Products from '../components/Products'
import NewsLetter from '../components/NewsLetter'
import Footer from '../components/Footer'
import Categories from '../components/Categories'

const Home = () => {
  return (

    <div style={{  overflowX: "hidden"}}>
       <Announcement />
      <Navbar />
      <Slider  />
      <Categories/>
      <Products/>
      <NewsLetter/>
      <Footer/>
    </div>
  )
}

export default Home
